// Sentry first, so it is up before anything else runs.
import './instrument';

import { Amplify } from 'aws-amplify';

import amplifyConfig from './configs/amplifyConfig';

Amplify.configure(amplifyConfig);
